/* jshint esversion: 6 */
/* jshint ignore:start */
import axios from 'axios';
import React, { useEffect, useContext, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import { showTost } from '../../showTost';
import Razorpay from '../Payment/RazorPay';
import Paypal from '../Payment/Paypal';
import Loading from '../../Loading';
import Stripe from '../Payment/Stripe';
import FlutterWave from '../Payment/FlutterWave';
import PayStack from '../Payment/PayStack';
import PayFast from '../Payment/PayFast';
import Midtrans from '../Payment/Midtrans';
import KhaltiPayment from '../Payment/KhaltiPayment';
import MercadoPago from '../Payment/MercadoPago';
import { useTranslation } from 'react-i18next';
import ThemedPageFrame from './ThemedPageFrame';

const Wallet = () => {

    const { t } = useTranslation();
    const { BaseUrl, paymentRes, setPaymentRes, paymentLoad, setPaymentLod } = useContext(MyContext);
    // const Userid = 0;
    const Userid = localStorage.getItem("Userid");
    const [input, setInput] = useState("");
    const [loading, setLoading] = useState(true);
    const [myWallet, setMyWallet] = useState("");
    const [paymentList, setPaymentList] = useState([]);
    const [isPayment, setIsPayment] = useState(false);
    const [selectPayment, setSelectPayment] = useState("");
    const [attributes, setAttributes] = useState();
    const [transactionList, setTransactionList] = useState([]);
    const [walletTransactionList, setWalletTransactionList] = useState([]);
    const [orderList, setOrderList] = useState([]);

    const site_currency = sessionStorage.getItem("currency");
    const currency = site_currency ? site_currency : "₹";

    useEffect(() => {
        window.scrollTo(0, 0);

        axios.post(`${BaseUrl}user_api/u_paymentgateway.php`)
            .then((res) => {
                setPaymentList(res.data.paymentdata);
                setLoading(false);
            })
            .catch((error) => {
                console.error("u_paymentgateway", error);
            });

        HandleGetList();


        const PaymentRes = sessionStorage.getItem("Paymentstatus");
        if (!PaymentRes) return;

        if (PaymentRes === "PaymentDone") {
            setPaymentRes("PaymentDone");
        } else {
            setPaymentRes("PaymentFaild");
        }

    }, []);

    const HandleGetList = () => {
        const Userid = localStorage.getItem("Userid");
        axios.post(`${BaseUrl}user_api/u_wallet_report.php`, { uid: Userid })
            .then((res) => {
                setTransactionList(res.data.Walletitem);
                setMyWallet(res.data.wallet);
            })
            .catch((error) => {
                console.error("u_wallet_report", error);
            });
    };

    const HnadleContinue = () => {

        if (paymentLoad) {
            showTost(t("Payment in Process !!"), "info");
            return;
        }

        if (!input) {
            showTost(t("Please Enter Amount !!"), "error");
            return;
        }

        if (!selectPayment) {
            showTost(t("Select Payment Method !!"), "error");
            return;
        }

        setIsPayment(true);
        setPaymentLod(true);
        sessionStorage.setItem("pages", "wallet");
    };

    useEffect(() => {
        if (!paymentRes) return;

        if (paymentRes === "PaymentDone") {
            HandleWalletAdd();
        } else {
            setInput("");
            setIsPayment(false);
            setSelectPayment("");
            setPaymentRes("");
            showTost("Payment Faild !!", "error");
            sessionStorage.setItem("Amount", "0");
            sessionStorage.setItem("Paymentstatus", "");
        }

    }, [paymentRes]);

    const HandleWalletAdd = () => {
        const Userid = localStorage.getItem("Userid");
        const Amount = sessionStorage.getItem("Amount");

        axios.post(`${BaseUrl}user_api/u_wallet_up.php`, { uid: Userid, wallet: input || Amount })
            .then((res) => {
                setInput("");
                HandleGetList();
                showTost(res.data.ResponseMsg, "success");
                setIsPayment(false);
                setPaymentRes("");
                setSelectPayment("");
                sessionStorage.setItem("Amount", "0");
                sessionStorage.setItem("Paymentstatus", "");
            })
            .catch((error) => {
                console.error("u_wallet_up", error);
            });
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        axios.post(
            `${BaseUrl}user_api/order_menu.php`,
            // { user_id: 103 },
            { user_id: Userid },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        )
            .then((res) => {
                if (res?.data?.status === true) {
                    setOrderList(res?.data);
                }
            })
            .catch((err) => {
                console.error('Error:', err.message);
            });
    }, [BaseUrl, Userid]);

    useEffect(() => {
        window.scrollTo(0, 0);
        axios.post(
            `${BaseUrl}user_api/stall_add_wallet_history.php`,
            { user_id: Userid },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        )
            .then((res) => {
                if (res?.data?.status === true) {
                    setWalletTransactionList(res?.data?.wallet_history);
                }
            })
            .catch((err) => {
                console.error('Error:', err.message);
            });
    }, [BaseUrl, Userid]);

    const walletTotal = walletTransactionList?.reduce((sum, item) => {
        return item.type === "credit"
            ? sum + Number(item.amount)
            : sum - Number(item.amount);
    }, 0);

    return (
        <ThemedPageFrame
            activePath="/wallet"
            eyebrow="NabhiVerse Wallet"
            title={t("Wallet")}
            subtitle={t("Track your balance, orders, and wallet transactions.")}
            summary={<><span>Balance</span><strong>{currency}{orderList?.orders?.length > 0 ? orderList?.order_detail?.remaining_amt ?? 0 : walletTotal ?? 0}</strong></>}
            className="legacy_themed_page wallet_page_layout"
        >
            <div className="wallet mt-[20px] flex justify-center">

                {/* <div className="paylist_box scroll-container">
                    <h1 className="font-bold text-[18px]">{t("Add Wallet")}</h1>
                    <h1 className="font-bold text-[15px] text-gray-600">{t("Your Current Wallet Balance is")} <span className="text-[red]">{currency}{myWallet}</span> </h1>
                    <input type="number" onChange={(e) => setInput(e.target.value)} value={input} className="w-[100%] border-[2px] border-gray-300 py-[8px] px-[10px] rounded-[10px] mt-[10px] focus-within:outline-gray-400" placeholder={t("Amount")} />

                    <div className="mt-[20px]">
                        <h1 className="font-bold ">{t("Select Payment Method")}</h1>

                        <div className="flex flex-wrap items-center gap-[10px] mt-[10px] max-h-[480px] scroll-container">
                            {paymentList?.map((item, index) => {
                                return <div onClick={() => { setSelectPayment(item.id); setAttributes(item.attributes) }} key={index} className={`payment_box border-[2px] border-solid ${selectPayment === item.id ? "border-gray-600" : "border-gray-300"} hover:border-gray-600r`}>
                                    <div className="flex items-center gap-[10px]">
                                    <img src={BaseUrl + item.img} className="w-[60px] h-[60px]" alt="" />
                                        <div className="">
                                            <h1 className="font-bold text-[16px] text-gray-700">{item.title}</h1>
                                            <p className="text-[14px] text-gray-500">{item.subtitle}</p>
                                        </div>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                    <button onClick={HnadleContinue} className="payment_button">
                        {paymentLoad ? <span className="loader2 -mb-[5px]"></span> : t("Continue")}
                    </button>
                </div> */}

                {/* <div className="transaction_box">
                    <h1 className="font-bold text-[16px]">{t("Your Recent Transaction")}</h1>
                    <div className="h-[665px] scroll-container">
                        {transactionList?.map((item, index) => {
                            return <div key={index} className="p-[20px] flex items-center justify-between">
                                <div className="flex items-center gap-[20px]">
                                    <svg width="27" height="27" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M22 6H6C3.79086 6 2 7.79086 2 10V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6Z" stroke="#28303F" stroke-width="1.5" stroke-linejoin="round" />
                                        <path d="M22 6C22 3.79086 20.2091 2 18 2H12C9.79086 2 8 3.79086 8 6V6H22V6Z" stroke="#28303F" stroke-width="1.5" stroke-linejoin="round" />
                                        <path d="M2 12L2 16L6 16C7.10457 16 8 15.1046 8 14V14C8 12.8954 7.10457 12 6 12L2 12Z" stroke="#28303F" stroke-width="1.5" stroke-linejoin="round" />
                                    </svg>
                                    <div className="">
                                        <h1 className="font-bold text-[15px]">{item.tdate}</h1>
                                        <span className="text-[14px] text-gray-600">{item.status}</span>
                                    </div>
                                </div>
                                <p className="text-[15px]">{item.status === "Debit" ? "-" : "+"}{currency}{item.amt}</p>
                            </div>
                        })}
                    </div>
                </div> */}

                <div className="paylist_box scroll-container">
                    <div className="flex justify-end">
                        <h1 className="font-bold text-[16px] text-white">
                            {t("Current Balance is : ")}
                            <span className="text-red-500">
                                {currency}
                                {orderList?.orders?.length > 0
                                    ? orderList?.order_detail?.remaining_amt ?? 0
                                    : walletTotal ?? 0}
                            </span>
                        </h1>
                    </div>

                    <div className="mt-4">
                        <div className="sm:flex justify-between items-center">
                            <h1 className="font-bold text-white">
                                {t("Your Orders")} ({orderList?.orders?.length ?? 0})
                            </h1>

                            <h1 className="font-bold text-[13px] text-white">
                                {t("Total Purchased : ")}
                                <span className="text-red-500">
                                    {currency}{orderList?.order_detail?.total_amount ?? 0}
                                </span>
                            </h1>
                        </div>

                        {/* ORDERS LIST / EMPTY STATE */}
                        <div className="mt-4 max-h-[480px] scroll-container">
                            {orderList?.orders?.length > 0 ? (
                                <div className="flex flex-wrap items-center gap-[10px]">
                                    {orderList.orders.map((item, index) => (
                                        <div
                                            key={index}
                                            className="payment_box border-[2px] border-gray-300 hover:border-gray-600"
                                        >
                                            <div className="flex justify-between">
                                                <h1 className="font-bold text-[16px] text-white">
                                                    {item.menu}
                                                </h1>
                                                <p className="text-[14px] text-gray-400">
                                                    {t("Total : ")}
                                                    {currency}
                                                    {item.price * item.qty}
                                                </p>
                                            </div>

                                            <p className="text-[14px] text-gray-400">
                                                Qty : {item.qty}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                /* EMPTY STATE */
                                <div className="flex flex-col items-center justify-center py-16 text-gray-500">
                                    <svg
                                        width="80"
                                        height="80"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        className="mb-4"
                                    >
                                        <path
                                            d="M3 3H5L6 16H18L20 6H6"
                                            stroke="#fff"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <circle cx="9" cy="20" r="1" fill="#fff" />
                                        <circle cx="17" cy="20" r="1" fill="#fff" />
                                    </svg>

                                    <h1 className="font-semibold text-[16px] text-white">
                                        {t("No Orders Found")}
                                    </h1>
                                    <p className="text-[13px] text-white">
                                        {t("You haven't placed any orders yet")}
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="transaction_box">
                    <h1 className="font-bold text-[16px] mb-3 text-white">
                        {t("Your Recent Transactions")}
                    </h1>

                    <div className="min-h-[200px] overflow-y-auto scroll-container">

                        {/* ✅ NO DATA */}
                        {(!walletTransactionList || walletTransactionList.length === 0) && (
                            <div className="h-[200px] flex flex-col items-center justify-center text-gray-500">
                                {/* SVG ICON */}
                                <svg
                                    width="70"
                                    height="70"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="mb-3 opacity-70"
                                >
                                    <path
                                        d="M3 7H21"
                                        stroke="#fff"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        d="M6 7V19C6 20.1046 6.89543 21 8 21H16C17.1046 21 18 20.1046 18 19V7"
                                        stroke="#fff"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        d="M9 11H15"
                                        stroke="#fff"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                </svg>

                                <p className="text-[14px] font-medium text-white">
                                    {t("No transactions found")}
                                </p>
                            </div>
                        )}

                        {/* ✅ TRANSACTION LIST */}
                        {walletTransactionList?.map((item, index) => {
                            const isDebit = item.type === "debit";

                            return (
                                <div
                                    key={index}
                                    className="px-5 py-4 flex items-center justify-between border-b border-gray-200"
                                >
                                    {/* LEFT */}
                                    <div className="flex items-center gap-4">
                                        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100">
                                            <svg
                                                width="27"
                                                height="27"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M22 6H6C3.79086 6 2 7.79086 2 10V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6Z"
                                                    stroke="#28303F"
                                                    strokeWidth="1.5"
                                                />
                                                <path
                                                    d="M22 6C22 3.79086 20.2091 2 18 2H12C9.79086 2 8 3.79086 8 6"
                                                    stroke="#28303F"
                                                    strokeWidth="1.5"
                                                />
                                            </svg>
                                        </div>

                                        <div>
                                            <h1 className="text-[14px] font-semibold">
                                                {item.remark}
                                            </h1>
                                            <p className="text-[12px] text-gray-500">
                                                {item.date}
                                            </p>
                                        </div>
                                    </div>

                                    {/* RIGHT */}
                                    <p
                                        className={`text-[15px] font-semibold ${isDebit ? "text-red-500" : "text-green-600"
                                            }`}
                                    >
                                        {isDebit ? "-" : "+"}
                                        {currency}
                                        {item.amount}
                                    </p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            {(isPayment && selectPayment === "4") && <Razorpay Amount={input} attributes={attributes} />}
            {(isPayment && selectPayment === "1") && <div onClick={() => { setSelectPayment(""); setIsPayment(false) }} id="BlockSection" className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
                    <div className="flex flex-col justify-center items-center text-center">
                        <Paypal Amount={input} attributes={attributes} />
                    </div>
                </div>
            </div>}
            {(isPayment && selectPayment === "2") && <div onClick={() => { setSelectPayment(""); setIsPayment(false) }} id="BlockSection" className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
                    <div className="flex flex-col justify-center items-center text-center">
                        <Stripe Amount={input} />
                    </div>
                </div>
            </div>}
            {(isPayment && selectPayment === "7") && <FlutterWave Amount={input} attributes={attributes} />}
            {(isPayment && selectPayment === "9") && <div onClick={() => { setSelectPayment(""); setIsPayment(false) }} id="BlockSection" className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
                    <div className="flex flex-col justify-center items-center text-center">
                        <PayStack Amount={input} attributes={attributes} />
                    </div>
                </div>
            </div>}
            {(isPayment && selectPayment === "12") && <PayFast Amount={input} attributes={attributes} />}
            {(isPayment && selectPayment === "13") && <Midtrans Amount={input} />}
            {(isPayment && selectPayment === "15") && <KhaltiPayment Amount={input} />}
            {(isPayment && selectPayment === "16") && <MercadoPago Amount={input} />}

            {loading && <Loading />}

        </ThemedPageFrame>
    )
}

export default Wallet
/* jshint ignore:end */
